import React from 'react';
import { FiSettings, FiMoon } from 'react-icons/fi';
import ThemeSelector from '../components/ThemeSelector';

// The Google Calendar sync panel lived here until 2026-08-25. It was never
// finished: the OAuth client was only ever registered against a localhost
// redirect URI, no account was ever authorized, and this page called
// /calendar/auth-status and /calendar/revoke, which the backend never defined.
// Google deleted the unused client for inactivity. Removed rather than left as
// a button that fails when clicked.

function Settings() {
  return (
    <div className="settings-page">
      <div className="page-header">
        <h1><FiSettings /> Settings</h1>
        <p className="subtitle">Manage your application settings</p>
      </div>

      {/* Appearance Section */}
      <div className="settings-section">
        <h2><FiMoon /> Appearance</h2>
        <p className="section-description">
          Customize how the app looks and feels. Choose from holiday themes or neon surveying themes!
        </p>

        <ThemeSelector />
      </div>

      <div className="settings-section">
        <h2>Application Information</h2>
        <div className="info-grid">
          <div className="info-item">
            <label>Version</label>
            <span>1.0.0</span>
          </div>
          <div className="info-item">
            <label>Database</label>
            <span>SQLite</span>
          </div>
          <div className="info-item">
            <label>Server</label>
            <span>Flask (Python)</span>
          </div>
          <div className="info-item">
            <label>Platform</label>
            <span>{window.Capacitor?.isNativePlatform?.() ? 'Mobile App' : 'Web Browser'}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
